import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';

const GenericNoContentDueToFilteringError = ({
  headingI18n,
  subtitleI18n,
  resetLink,
  onReset
}) => /*#__PURE__*/_jsx(UIErrorMessage, {
  className: "no-content-error",
  "data-test-id": "no-content-error",
  illustration: "empty-state-charts",
  title: /*#__PURE__*/_jsx("h4", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.errors.filters.${headingI18n}`
    })
  }),
  children: /*#__PURE__*/_jsxs("p", {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.errors.filters.common.${subtitleI18n}`
    }), /*#__PURE__*/_jsx("br", {}), resetLink && /*#__PURE__*/_jsx(UIRouterLink, {
      "data-test-id": "clear-all-filters",
      onClick: onReset,
      to: resetLink,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.errors.filters.common.clearFilters"
      })
    })]
  })
});

export default GenericNoContentDueToFilteringError;